export function isAlbumDetailRoute(path) {
  const parts = path.replace(/\/$/, '').split('/').filter(Boolean);
  if (parts[0] !== 'reviews' || ['upload', 'edit'].includes(parts[1])) return false;
  if (parts.length === 2) return true;
  if (parts.length === 3)
    return !['user-reviews', 'related-albums', 'critic-reviews'].includes(parts[2]);
  return (
    (parts.length === 4 && parts[2] === 'comment') || (parts.length === 5 && parts[3] === 'comment')
  );
}
